/* eslint-disable no-shadow */
const state = {
	brandProductsData: []
}

const getters = {
	getBrandProductsData: state => state.brandProductsData
}

const mutations = {
	setBrandProductsDataMutation: (state, payload) => {
		state.brandProductsData = payload
	}
}

const actions = {
	setBrandsData: ({ commit }, payload) => {
		commit('setBrandProductsDataMutation', payload)
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
